// Client for accounts + workspace membership.

export interface Member {
  email: string;
  role: string;
}

async function j(res: Response): Promise<any> {
  if (!res.ok) throw new Error((await res.text()) || `HTTP ${res.status}`);
  return res.json();
}

export async function getMe(): Promise<{ email: string | null }> {
  try {
    const r = await fetch("/api/auth/me");
    if (!r.ok) return { email: null };
    return r.json();
  } catch {
    return { email: null };
  }
}
export async function signup(email: string, password: string): Promise<{ email: string }> {
  return j(await fetch("/api/auth/signup", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, password }) }));
}
export async function login(email: string, password: string): Promise<{ email: string }> {
  return j(await fetch("/api/auth/login", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, password }) }));
}
export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST" });
}
export async function resetRequest(email: string): Promise<{ ok: boolean; emailConfigured?: boolean; emailed?: boolean }> {
  return j(await fetch("/api/auth/reset-request", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) }));
}
export async function resetPassword(token: string, password: string): Promise<{ email: string }> {
  return j(await fetch("/api/auth/reset", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, password }) }));
}
// Workspaces owned by the signed-in user (so their ledgers load on login).
export async function getMyLedgers(): Promise<{ workspaces: string[]; needLogin?: boolean }> {
  const r = await fetch("/api/my-ledgers");
  if (r.status === 401) return { workspaces: [], needLogin: true };
  return r.json();
}
// Owner contract projects synced to the account.
export async function getSyncedContracts(): Promise<{ data: Record<string, any> | null; version: number; needLogin?: boolean }> {
  const r = await fetch("/api/contracts");
  if (r.status === 401) return { data: null, version: 0, needLogin: true };
  return r.json();
}
export async function putSyncedContracts(data: Record<string, any>): Promise<{ ok?: boolean; version?: number; needLogin?: boolean }> {
  const r = await fetch("/api/contracts", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ data }) });
  if (r.status === 401) return { needLogin: true };
  return r.json();
}

export async function getMembers(ws: string): Promise<{ owned?: boolean; isOwner?: boolean; members?: Member[]; needLogin?: boolean; forbidden?: boolean }> {
  const r = await fetch(`/api/ledger/${ws}/members`);
  return r.json();
}
export async function setMember(ws: string, email: string, opts: { remove?: boolean; role?: "editor" | "viewer" } = {}): Promise<{ members: Member[] }> {
  return j(await fetch(`/api/ledger/${ws}/members`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, remove: opts.remove, role: opts.role }) }));
}
